export interface PollingParams {

  /**
   * 轮询请求
   */
  requestFunction: () => Promise<any>;

  /**
   * 成功回调
   */
  onSuccess: (data: any) => void;

  /**
   * 成功态判断
   */
  checkSuccess: (data: any) => boolean;

  /**
   * 异常回调
   */
  onError?: (error: any) => void;

  /**
   * 失败态判断
   */
  checkError?: (error: any) => boolean;

  /**
   * 请求间隔，兜底 300ms
   */
  timeout?: number;
}

export const createPolling = ({
  requestFunction,
  timeout = 300,
  onSuccess,
  checkSuccess,
  onError,
  checkError,
}: PollingParams): void => {
  async function fetchData () {
    try {
      const res = await requestFunction()
      if (checkSuccess(res)) {
        onSuccess(res)
      } else if (checkError?.(res)) {
        throw res
      } else {
        setTimeout(() => {
          fetchData()
        }, timeout)
      }
    } catch (error) {
      onError?.(error)
    }
  }
  fetchData()
}
